import { RIDCContractorStatus } from "@/constants/request/RIDCConstants";
import { ResidencyStatus } from "@/constants/PersonConstants";
import FileMetaDTO from "@/dto/files/FileMetaDTO";
import { ContractType } from "@/constants/EmploymentType";

export class PublicRIDCContractorDTO {

    id!: number;
    status!: RIDCContractorStatus;
    companyName!: string;
    companyId!: number;
    name!: string;
    email: string | null = null;
    phone: string | null = null;
    actualizationOnly!: boolean;
    residencyStatus: ResidencyStatus | null = null;
    ssnImage: FileMetaDTO | null = null;
    greenCardImage: FileMetaDTO | null = null;
    greenCardFrontImage: FileMetaDTO | null = null;
    greenCardBackImage: FileMetaDTO | null = null;
    citizenPassportImage: FileMetaDTO | null = null;
    eadFrontImage: FileMetaDTO | null = null;
    eadBackImage: FileMetaDTO | null = null;
    stateIdFrontImage: FileMetaDTO | null = null;
    stateIdBackImage: FileMetaDTO | null = null;
    foreignPassportTitleImage: FileMetaDTO | null = null;
    foreignPassportVisaImage: FileMetaDTO | null = null;
    voidCheckImage: FileMetaDTO | null = null;
    addressConfirmationImage: FileMetaDTO | null = null;
    contractStart!: Date;
    signedW9: FileMetaDTO | null = null;
    currentAccountNumber: string | null = null;
    currentAccountRoutingNumber: string | null = null;
    currentAccountBank: string | null = null;

    saveWithoutStateIdBack = false;
    currentAccountIsValid = false;
    stateIDValid = false;
    ssnRequired = true;
    citizenPassportRequired = true;
    bankDetailsRequired = true;
    eadRequired = true;
    stateIdRequired = true;
    greenCardRequired = true;
    stateIdIsValid = false;
    latestStateIdState: string | null = null;
    latestStateIdExpirationDate: Date | null = null;
    currentBankAccount: string | null = null;
    contractType!: ContractType;
    branchIds: number[] = [];

    constructor(init?: Partial<PublicRIDCContractorDTO>) {
        Object.assign(this, init);
    }
}
